import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLegend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.541016 11.5287V10.2789H13.4577V11.5287H0.541016ZM0.541016 8.29165V7.04165H13.4577V8.29165H0.541016ZM0.541016 4.89415V3.42477L5.32477 0.51123L9.49935 3.47748L13.4577 0.663522V2.2004L9.49935 5.00644L5.2781 2.01436L0.541016 4.89415Z",
		fill: "currentColor"
	})
});
export default SvgLegend;
